function cov_1qgqgcnxqf() {
  var path = "/codebuild/output/src315236701/src/src/common/utils/createHistoryStore.ts";
  var hash = "4a37dc5f277042189024d06668ef50e620bd3115";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/common/utils/createHistoryStore.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 166,
          column: 7
        }
      },
      "1": {
        start: {
          line: 9,
          column: 22
        },
        end: {
          line: 17,
          column: 9
        }
      },
      "2": {
        start: {
          line: 19,
          column: 32
        },
        end: {
          line: 19,
          column: 49
        }
      },
      "3": {
        start: {
          line: 20,
          column: 32
        },
        end: {
          line: 20,
          column: 65
        }
      },
      "4": {
        start: {
          line: 22,
          column: 49
        },
        end: {
          line: 22,
          column: 54
        }
      },
      "5": {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 24,
          column: 32
        }
      },
      "6": {
        start: {
          line: 24,
          column: 20
        },
        end: {
          line: 24,
          column: 32
        }
      },
      "7": {
        start: {
          line: 25,
          column: 16
        },
        end: {
          line: 28,
          column: 18
        }
      },
      "8": {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 41,
          column: 19
        }
      },
      "9": {
        start: {
          line: 51,
          column: 16
        },
        end: {
          line: 52,
          column: 27
        }
      },
      "10": {
        start: {
          line: 52,
          column: 20
        },
        end: {
          line: 52,
          column: 27
        }
      },
      "11": {
        start: {
          line: 53,
          column: 16
        },
        end: {
          line: 53,
          column: 46
        }
      },
      "12": {
        start: {
          line: 61,
          column: 64
        },
        end: {
          line: 61,
          column: 68
        }
      },
      "13": {
        start: {
          line: 63,
          column: 16
        },
        end: {
          line: 63,
          column: 51
        }
      },
      "14": {
        start: {
          line: 64,
          column: 16
        },
        end: {
          line: 64,
          column: 53
        }
      },
      "15": {
        start: {
          line: 66,
          column: 16
        },
        end: {
          line: 69,
          column: 17
        }
      },
      "16": {
        start: {
          line: 67,
          column: 20
        },
        end: {
          line: 67,
          column: 43
        }
      },
      "17": {
        start: {
          line: 68,
          column: 20
        },
        end: {
          line: 68,
          column: 38
        }
      },
      "18": {
        start: {
          line: 71,
          column: 16
        },
        end: {
          line: 91,
          column: 19
        }
      },
      "19": {
        start: {
          line: 72,
          column: 20
        },
        end: {
          line: 90,
          column: 21
        }
      },
      "20": {
        start: {
          line: 74,
          column: 44
        },
        end: {
          line: 74,
          column: 61
        }
      },
      "21": {
        start: {
          line: 75,
          column: 24
        },
        end: {
          line: 75,
          column: 48
        }
      },
      "22": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 76,
          column: 58
        }
      },
      "23": {
        start: {
          line: 78,
          column: 41
        },
        end: {
          line: 78,
          column: 79
        }
      },
      "24": {
        start: {
          line: 79,
          column: 24
        },
        end: {
          line: 79,
          column: 45
        }
      },
      "25": {
        start: {
          line: 80,
          column: 24
        },
        end: {
          line: 80,
          column: 42
        }
      },
      "26": {
        start: {
          line: 81,
          column: 24
        },
        end: {
          line: 81,
          column: 48
        }
      },
      "27": {
        start: {
          line: 82,
          column: 24
        },
        end: {
          line: 82,
          column: 54
        }
      },
      "28": {
        start: {
          line: 84,
          column: 24
        },
        end: {
          line: 84,
          column: 57
        }
      },
      "29": {
        start: {
          line: 86,
          column: 24
        },
        end: {
          line: 86,
          column: 42
        }
      },
      "30": {
        start: {
          line: 89,
          column: 24
        },
        end: {
          line: 89,
          column: 36
        }
      },
      "31": {
        start: {
          line: 97,
          column: 16
        },
        end: {
          line: 97,
          column: 48
        }
      },
      "32": {
        start: {
          line: 103,
          column: 16
        },
        end: {
          line: 103,
          column: 48
        }
      },
      "33": {
        start: {
          line: 111,
          column: 16
        },
        end: {
          line: 143,
          column: 19
        }
      },
      "34": {
        start: {
          line: 112,
          column: 40
        },
        end: {
          line: 112,
          column: 57
        }
      },
      "35": {
        start: {
          line: 113,
          column: 20
        },
        end: {
          line: 113,
          column: 44
        }
      },
      "36": {
        start: {
          line: 114,
          column: 20
        },
        end: {
          line: 114,
          column: 54
        }
      },
      "37": {
        start: {
          line: 115,
          column: 36
        },
        end: {
          line: 115,
          column: 53
        }
      },
      "38": {
        start: {
          line: 116,
          column: 56
        },
        end: {
          line: 116,
          column: 60
        }
      },
      "39": {
        start: {
          line: 117,
          column: 32
        },
        end: {
          line: 117,
          column: 80
        }
      },
      "40": {
        start: {
          line: 118,
          column: 20
        },
        end: {
          line: 121,
          column: 21
        }
      },
      "41": {
        start: {
          line: 119,
          column: 24
        },
        end: {
          line: 119,
          column: 38
        }
      },
      "42": {
        start: {
          line: 120,
          column: 24
        },
        end: {
          line: 120,
          column: 31
        }
      },
      "43": {
        start: {
          line: 122,
          column: 20
        },
        end: {
          line: 142,
          column: 21
        }
      },
      "44": {
        start: {
          line: 124,
          column: 36
        },
        end: {
          line: 124,
          column: 63
        }
      },
      "45": {
        start: {
          line: 126,
          column: 24
        },
        end: {
          line: 126,
          column: 50
        }
      },
      "46": {
        start: {
          line: 127,
          column: 24
        },
        end: {
          line: 127,
          column: 53
        }
      },
      "47": {
        start: {
          line: 128,
          column: 24
        },
        end: {
          line: 129,
          column: 46
        }
      },
      "48": {
        start: {
          line: 129,
          column: 28
        },
        end: {
          line: 129,
          column: 46
        }
      },
      "49": {
        start: {
          line: 131,
          column: 37
        },
        end: {
          line: 131,
          column: 60
        }
      },
      "50": {
        start: {
          line: 132,
          column: 41
        },
        end: {
          line: 132,
          column: 68
        }
      },
      "51": {
        start: {
          line: 133,
          column: 24
        },
        end: {
          line: 134,
          column: 46
        }
      },
      "52": {
        start: {
          line: 134,
          column: 28
        },
        end: {
          line: 134,
          column: 46
        }
      },
      "53": {
        start: {
          line: 135,
          column: 24
        },
        end: {
          line: 135,
          column: 42
        }
      },
      "54": {
        start: {
          line: 139,
          column: 24
        },
        end: {
          line: 140,
          column: 46
        }
      },
      "55": {
        start: {
          line: 140,
          column: 28
        },
        end: {
          line: 140,
          column: 46
        }
      },
      "56": {
        start: {
          line: 141,
          column: 24
        },
        end: {
          line: 141,
          column: 36
        }
      },
      "57": {
        start: {
          line: 151,
          column: 16
        },
        end: {
          line: 152,
          column: 27
        }
      },
      "58": {
        start: {
          line: 152,
          column: 20
        },
        end: {
          line: 152,
          column: 27
        }
      },
      "59": {
        start: {
          line: 153,
          column: 37
        },
        end: {
          line: 153,
          column: 39
        }
      },
      "60": {
        start: {
          line: 155,
          column: 16
        },
        end: {
          line: 159,
          column: 19
        }
      },
      "61": {
        start: {
          line: 156,
          column: 20
        },
        end: {
          line: 157,
          column: 45
        }
      },
      "62": {
        start: {
          line: 157,
          column: 24
        },
        end: {
          line: 157,
          column: 45
        }
      },
      "63": {
        start: {
          line: 158,
          column: 20
        },
        end: {
          line: 158,
          column: 41
        }
      },
      "64": {
        start: {
          line: 161,
          column: 16
        },
        end: {
          line: 161,
          column: 84
        }
      },
      "65": {
        start: {
          line: 161,
          column: 57
        },
        end: {
          line: 161,
          column: 82
        }
      },
      "66": {
        start: {
          line: 163,
          column: 16
        },
        end: {
          line: 163,
          column: 52
        }
      }
    },
    fnMap: {
      "0": {
        name: "createHistoryStore",
        decl: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 34
          }
        },
        loc: {
          start: {
            line: 7,
            column: 39
          },
          end: {
            line: 167,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 15
          },
          end: {
            line: 9,
            column: 16
          }
        },
        loc: {
          start: {
            line: 9,
            column: 22
          },
          end: {
            line: 17,
            column: 9
          }
        },
        line: 9
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 21
          },
          end: {
            line: 19,
            column: 22
          }
        },
        loc: {
          start: {
            line: 19,
            column: 32
          },
          end: {
            line: 19,
            column: 49
          }
        },
        line: 19
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 21
          },
          end: {
            line: 20,
            column: 22
          }
        },
        loc: {
          start: {
            line: 20,
            column: 32
          },
          end: {
            line: 20,
            column: 65
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 21,
            column: 26
          },
          end: {
            line: 21,
            column: 27
          }
        },
        loc: {
          start: {
            line: 21,
            column: 37
          },
          end: {
            line: 29,
            column: 13
          }
        },
        line: 21
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 13
          }
        },
        loc: {
          start: {
            line: 35,
            column: 20
          },
          end: {
            line: 42,
            column: 13
          }
        },
        line: 35
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 50,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        },
        loc: {
          start: {
            line: 50,
            column: 38
          },
          end: {
            line: 54,
            column: 13
          }
        },
        line: 50
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 60,
            column: 13
          }
        },
        loc: {
          start: {
            line: 60,
            column: 41
          },
          end: {
            line: 92,
            column: 13
          }
        },
        line: 60
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 71,
            column: 35
          },
          end: {
            line: 71,
            column: 36
          }
        },
        loc: {
          start: {
            line: 71,
            column: 62
          },
          end: {
            line: 91,
            column: 17
          }
        },
        line: 71
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 96,
            column: 12
          },
          end: {
            line: 96,
            column: 13
          }
        },
        loc: {
          start: {
            line: 96,
            column: 25
          },
          end: {
            line: 98,
            column: 13
          }
        },
        line: 96
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 102,
            column: 13
          }
        },
        loc: {
          start: {
            line: 102,
            column: 25
          },
          end: {
            line: 104,
            column: 13
          }
        },
        line: 102
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 109,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        },
        loc: {
          start: {
            line: 109,
            column: 38
          },
          end: {
            line: 144,
            column: 13
          }
        },
        line: 109
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 111,
            column: 35
          },
          end: {
            line: 111,
            column: 36
          }
        },
        loc: {
          start: {
            line: 111,
            column: 62
          },
          end: {
            line: 143,
            column: 17
          }
        },
        line: 111
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 150,
            column: 12
          },
          end: {
            line: 150,
            column: 13
          }
        },
        loc: {
          start: {
            line: 150,
            column: 40
          },
          end: {
            line: 164,
            column: 13
          }
        },
        line: 150
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 155,
            column: 45
          },
          end: {
            line: 155,
            column: 46
          }
        },
        loc: {
          start: {
            line: 155,
            column: 55
          },
          end: {
            line: 159,
            column: 17
          }
        },
        line: 155
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 161,
            column: 47
          },
          end: {
            line: 161,
            column: 48
          }
        },
        loc: {
          start: {
            line: 161,
            column: 57
          },
          end: {
            line: 161,
            column: 82
          }
        },
        line: 161
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 16
          },
          end: {
            line: 24,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 16
          },
          end: {
            line: 24,
            column: 32
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 52,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 52,
            column: 27
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 66,
            column: 16
          },
          end: {
            line: 69,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 16
          },
          end: {
            line: 69,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 66
      },
      "3": {
        loc: {
          start: {
            line: 117,
            column: 32
          },
          end: {
            line: 117,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 117,
            column: 42
          },
          end: {
            line: 117,
            column: 53
          }
        }, {
          start: {
            line: 117,
            column: 58
          },
          end: {
            line: 117,
            column: 79
          }
        }],
        line: 117
      },
      "4": {
        loc: {
          start: {
            line: 118,
            column: 20
          },
          end: {
            line: 121,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 20
          },
          end: {
            line: 121,
            column: 21
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 118
      },
      "5": {
        loc: {
          start: {
            line: 124,
            column: 36
          },
          end: {
            line: 124,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 124,
            column: 45
          },
          end: {
            line: 124,
            column: 51
          }
        }, {
          start: {
            line: 124,
            column: 54
          },
          end: {
            line: 124,
            column: 63
          }
        }],
        line: 124
      },
      "6": {
        loc: {
          start: {
            line: 128,
            column: 24
          },
          end: {
            line: 129,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 24
          },
          end: {
            line: 129,
            column: 46
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 128
      },
      "7": {
        loc: {
          start: {
            line: 133,
            column: 24
          },
          end: {
            line: 134,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 24
          },
          end: {
            line: 134,
            column: 46
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 133
      },
      "8": {
        loc: {
          start: {
            line: 139,
            column: 24
          },
          end: {
            line: 140,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 24
          },
          end: {
            line: 140,
            column: 46
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 139
      },
      "9": {
        loc: {
          start: {
            line: 151,
            column: 16
          },
          end: {
            line: 152,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 16
          },
          end: {
            line: 152,
            column: 27
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 151
      },
      "10": {
        loc: {
          start: {
            line: 156,
            column: 20
          },
          end: {
            line: 157,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 156,
            column: 20
          },
          end: {
            line: 157,
            column: 45
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 156
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/common/utils/createHistoryStore.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/src/common/utils/createHistoryStore.ts"],
      names: [],
      mappings: "AAEA;;;;;GAKG;AACH,MAAM,UAAU,kBAAkB,CAAoB,EAAM;IAC1D,OAAO,WAAW,CAAC,EAAE,EAAE;QACrB,KAAK,EAAE,GAAG,EAAE,CAAC,CAAC;YACZ,GAAG,EAAE,EAAE;YACP,QAAQ,EAAE,EAAE;YACZ,IAAI,EAAE,EAAE;YACR,OAAO,EAAE,CAAC;YACV,KAAK,EAAE,EAAE;YACT,WAAW,EAAE,IAAI;YACjB,gBAAgB,EAAE,KAAK;SACxB,CAAC;QAEF,OAAO,EAAE;YACP,OAAO,EAAE,CAAC,KAAK,EAAW,EAAE,CAAC,KAAK,CAAC,OAAO,GAAG,CAAC;YAC9C,OAAO,EAAE,CAAC,KAAK,EAAW,EAAE,CAAC,KAAK,CAAC,OAAO,GAAG,KAAK,CAAC,IAAI,CAAC,MAAM;YAC9D,YAAY,EAAE,CAAC,KAAK,EAAE,EAAE;gBACtB,MAAM,EAAE,IAAI,EAAE,OAAO,EAAE,KAAK,EAAE,GAAG,KAAK,CAAC;gBAEvC,IAAI,OAAO,KAAK,CAAC;oBAAE,OAAO,IAAI,CAAC;gBAE/B,OAAO;oBACL,OAAO,EAAE,IAAI,CAAC,OAAO,GAAG,CAAC,CAAC;oBAC1B,IAAI,EAAE,KAAK,CAAC,OAAO,GAAG,CAAC,CAAC;iBACzB,CAAC;YACJ,CAAC;SACF;QAED,OAAO,EAAE;YACP;;eAEG;YACH,KAAK;gBACH,IAAI,CAAC,MAAM,CAAC;oBACV,IAAI,EAAE,EAAE;oBACR,OAAO,EAAE,CAAC;oBACV,KAAK,EAAE,EAAE;oBACT,gBAAgB,EAAE,KAAK;iBACxB,CAAC,CAAC;YACL,CAAC;YAED;;;;;;eAMG;YACH,UAAU,CAAC,IAAY,EAAE,OAAgB;gBACvC,IAAI,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC;oBAAE,OAAO;gBAChC,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,GAAG,OAAO,CAAC;YAChC,CAAC;YAED;;;;eAIG;YACH,KAAK,CAAC,OAAO,CAAC,IAAY,EAAE,GAAG,IAAI;gBACjC,MAAM,EAAE,QAAQ,EAAE,IAAI,EAAE,KAAK,EAAE,OAAO,EAAE,GAAG,EAAE,GAAG,IAAI,CAAC;gBACrD,2CAA2C;gBAC3C,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,EAAE,OAAO,CAAC,CAAC;gBACnC,IAAI,CAAC,KAAK,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,EAAE,OAAO,CAAC,CAAC;gBACrC,6DAA6D;gBAC7D,IAAI,IAAI,CAAC,MAAM,IAAI,GAAG,EAAE;oBACtB,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;oBACvB,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;iBACnB;gBACD,qDAAqD;gBACrD,OAAO,IAAI,OAAO,CAAC,KAAK,EAAE,OAAO,EAAE,MAAM,EAAE,EAAE;oBAC3C,IAAI;wBACF,uCAAuC;wBACvC,MAAM,WAAW,GAAG,IAAI,CAAC,KAAK,CAAC,MAAM,CAAC;wBACtC,MAAM,IAAI,CAAC,KAAK,CAAC,EAAE,CAAC,CAAC,CAAC,CAAC,CAAC;wBACxB,IAAI,CAAC,KAAK,CAAC,MAAM,CAAC,WAAW,EAAE,CAAC,CAAC,CAAC;wBAClC,eAAe;wBACf,MAAM,QAAQ,GAAG,MAAM,QAAQ,CAAC,IAAI,CAAC,EAAE,OAAO,CAAC,GAAG,IAAI,CAAC,CAAC;wBACxD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;wBACrB,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;wBAClB,IAAI,CAAC,WAAW,GAAG,IAAI,CAAC;wBACxB,IAAI,CAAC,gBAAgB,GAAG,KAAK,CAAC;wBAC9B,wDAAwD;wBACxD,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,EAAE,GAAG,QAAQ,EAAE,CAAC,CAAC;wBACjC,0BAA0B;wBAC1B,OAAO,CAAC,QAAQ,CAAC,CAAC;qBACnB;oBAAC,OAAO,GAAG,EAAE;wBACZ,MAAM,CAAC,GAAG,CAAC,CAAC;qBACb;gBACH,CAAC,CAAC,CAAC;YACL,CAAC;YAED;;eAEG;YACH,KAAK,CAAC,IAAI;gBACR,OAAO,IAAI,CAAC,WAAW,CAAC,MAAM,CAAC,CAAC;YAClC,CAAC;YAED;;eAEG;YACH,KAAK,CAAC,IAAI;gBACR,OAAO,IAAI,CAAC,WAAW,CAAC,MAAM,CAAC,CAAC;YAClC,CAAC;YAED;;;eAGG;YACH,KAAK,CAAC,WAAW,CAAC,MAAuB;gBACvC,qDAAqD;gBACrD,OAAO,IAAI,OAAO,CAAC,KAAK,EAAE,OAAO,EAAE,MAAM,EAAE,EAAE;oBAC3C,MAAM,WAAW,GAAG,IAAI,CAAC,KAAK,CAAC,MAAM,CAAC;oBACtC,MAAM,IAAI,CAAC,KAAK,CAAC,EAAE,CAAC,CAAC,CAAC,CAAC,CAAC;oBACxB,IAAI,CAAC,KAAK,CAAC,MAAM,CAAC,WAAW,EAAE,CAAC,CAAC,CAAC;oBAElC,MAAM,MAAM,GAAG,CAAC,MAAM,KAAK,MAAM,CAAC,CAAC;oBACnC,MAAM,EAAE,QAAQ,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,IAAI,CAAC;oBACzC,MAAM,GAAG,GAAG,MAAM,CAAC,CAAC,CAAC,CAAC,OAAO,GAAG,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,OAAO,GAAG,IAAI,CAAC,MAAM,CAAC,CAAC;oBAE7D,IAAI,CAAC,GAAG,EAAE;wBACR,OAAO,CAAC,IAAI,CAAC,CAAC;wBACd,OAAO;qBACR;oBAED,IAAI;wBACF,uCAAuC;wBACvC,MAAM,GAAG,GAAG,MAAM,CAAC,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,SAAS,CAAC;wBACxC,yCAAyC;wBACzC,IAAI,CAAC,WAAW,GAAG,MAAM,CAAC;wBAC1B,IAAI,CAAC,gBAAgB,GAAG,IAAI,CAAC;wBAE7B,IAAI,MAAM,KAAK,MAAM;4BAAE,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;wBACzC,4CAA4C;wBAC5C,MAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;wBACrC,MAAM,QAAQ,GAAG,MAAM,QAAQ,CAAC,IAAI,CAAC,CAAC,GAAG,CAAC,EAAE,CAAC;wBAC7C,IAAI,MAAM,KAAK,MAAM;4BAAE,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;wBACzC,OAAO,CAAC,QAAQ,CAAC,CAAC;qBACnB;oBAAC,OAAO,GAAG,EAAE;wBACZ,iDAAiD;wBACjD,IAAI,MAAM,KAAK,MAAM;4BAAE,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;wBACzC,MAAM,CAAC,GAAG,CAAC,CAAC;qBACb;gBACH,CAAC,CAAC,CAAC;YACL,CAAC;YAED;;;;eAIG;YACH,kBAAkB,CAAC,OAAe;gBAChC,IAAI,CAAC,CAAC,OAAO,IAAI,IAAI,CAAC,QAAQ,CAAC;oBAAE,OAAO;gBAExC,MAAM,YAAY,GAAG,EAAE,CAAC;gBACxB,qBAAqB;gBACrB,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,CAAC,EAAE,CAAC,EAAE,EAAE;oBACpC,IAAI,CAAC,KAAK,OAAO;wBAAE,YAAY,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC;oBACxC,OAAO,CAAC,KAAK,OAAO,CAAC;gBACvB,CAAC,CAAC,CAAC;gBACH,kBAAkB;gBAClB,IAAI,CAAC,KAAK,GAAG,IAAI,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC,CAAC,EAAE,CAAC,EAAE,EAAE,CAAC,CAAC,YAAY,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,CAAC;gBACpE,iBAAiB;gBACjB,IAAI,CAAC,OAAO,IAAI,YAAY,CAAC,MAAM,CAAC;YACtC,CAAC;SACF;KACF,CAAC,CAAC;AACL,CAAC;AAED,eAAe,kBAAkB,CAAC",
      sourcesContent: ["import { Command } from '@/common/interfaces';\n\n/**\n * Create a new pinia store with the same options\n * that History store with different id\n * @param id - Pinia id\n * @returns - History pinia store with different id\n */\nexport function createHistoryStore<Id extends string>(id: Id) {\n  return defineStore(id, {\n    state: () => ({\n      max: 25,\n      commands: {},\n      list: [],\n      current: 0,\n      queue: [],\n      lastCommand: null,\n      hasCommandCalled: false,\n    }),\n\n    getters: {\n      canUndo: (state): boolean => state.current > 0,\n      canRedo: (state): boolean => state.current < state.list.length,\n      currentValue: (state) => {\n        const { list, current, queue } = state;\n\n        if (current === 0) return null;\n\n        return {\n          command: list[current - 1],\n          data: queue[current - 1],\n        };\n      },\n    },\n\n    actions: {\n      /**\n       * Reset the store values but not the actions\n       */\n      reset() {\n        this.$patch({\n          list: [],\n          current: 0,\n          queue: [],\n          hasCommandCalled: false,\n        });\n      },\n\n      /**\n       * Add commands to use for undo/redo\n       * inspiration http://blog.danielherzog.es/2017-01-04-javascript-command-pattern/\n       * && https://github.com/yassilah/pinia-plugin-history/blob/main/src/index.ts\n       * @param name => the command name\n       * @param command => the commands should have an undo/redo function\n       */\n      addCommand(name: string, command: Command) {\n        if (this.commands[name]) return;\n        this.commands[name] = command;\n      },\n\n      /**\n       * Execute a given command\n       * @param name => the command name\n       * @param args => all other arguments to pass into the command\n       */\n      async execute(name: string, ...args) {\n        const { commands, list, queue, current, max } = this;\n        // remove any items after the current index\n        this.list = list.slice(0, current);\n        this.queue = queue.slice(0, current);\n        // if we hit the max amount of history remove the last action\n        if (list.length >= max) {\n          this.list.splice(0, 1);\n          this.current -= 1;\n        }\n        // eslint-disable-next-line no-async-promise-executor\n        return new Promise(async (resolve, reject) => {\n          try {\n            // wait for the last promise to resolve\n            const queueLength = this.queue.length;\n            await this.queue.at(-1);\n            this.queue.splice(queueLength, 1);\n            // Exec command\n            const response = await commands[name]?.execute(...args);\n            this.list.push(name);\n            this.current += 1;\n            this.lastCommand = null;\n            this.hasCommandCalled = false;\n            // add response to the queue to stop any race conditions\n            this.queue.push({ ...response });\n            // Return promise response\n            resolve(response);\n          } catch (err) {\n            reject(err);\n          }\n        });\n      },\n\n      /**\n       * Redo the last undone command\n       */\n      async redo() {\n        return this.stackMethod('redo');\n      },\n\n      /**\n       * Undo the last command\n       */\n      async undo() {\n        return this.stackMethod('undo');\n      },\n\n      /**\n       * Undo/redo stack method\n       * @param method => undo or redo string\n       */\n      async stackMethod(method: 'undo' | 'redo') {\n        // eslint-disable-next-line no-async-promise-executor\n        return new Promise(async (resolve, reject) => {\n          const queueLength = this.queue.length;\n          await this.queue.at(-1);\n          this.queue.splice(queueLength, 1);\n\n          const isUndo = (method === 'undo');\n          const { commands, list, current } = this;\n          const can = isUndo ? (current > 0) : (current < list.length);\n\n          if (!can) {\n            resolve('ok');\n            return;\n          }\n\n          try {\n            // wait for the last promise to resolve\n            const cmd = isUndo ? 'undo' : 'execute';\n            // Set here to get new value before await\n            this.lastCommand = method;\n            this.hasCommandCalled = true;\n\n            if (method === 'undo') this.current -= 1;\n            // Move back, and undo the previous command.\n            const name = this.list[this.current];\n            const response = await commands[name][cmd]();\n            if (method === 'redo') this.current += 1;\n            resolve(response);\n          } catch (err) {\n            // increase the current index as this undo failed\n            if (method === 'undo') this.current += 1;\n            reject(err);\n          }\n        });\n      },\n\n      /**\n       * Check if command exists in state and remove\n       * all states related with it.\n       * @param command - Command to delete\n       */\n      removeHistoryItems(command: string) {\n        if (!(command in this.commands)) return;\n\n        const queueIndexes = [];\n        // Remove in commands\n        this.list = this.list.filter((c, i) => {\n          if (c === command) queueIndexes.push(i);\n          return c !== command;\n        });\n        // Remove in queue\n        this.queue = this.queue.filter((v, i) => !queueIndexes.includes(i));\n        // Update current\n        this.current -= queueIndexes.length;\n      },\n    },\n  });\n}\n\nexport default createHistoryStore;\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4a37dc5f277042189024d06668ef50e620bd3115"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1qgqgcnxqf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1qgqgcnxqf();
import "core-js/modules/es.array.push.js";
/**
 * Create a new pinia store with the same options
 * that History store with different id
 * @param id - Pinia id
 * @returns - History pinia store with different id
 */
export function createHistoryStore(id) {
  cov_1qgqgcnxqf().f[0]++;
  cov_1qgqgcnxqf().s[0]++;
  return defineStore(id, {
    state: () => {
      cov_1qgqgcnxqf().f[1]++;
      cov_1qgqgcnxqf().s[1]++;
      return {
        max: 25,
        commands: {},
        list: [],
        current: 0,
        queue: [],
        lastCommand: null,
        hasCommandCalled: false
      };
    },
    getters: {
      canUndo: state => {
        cov_1qgqgcnxqf().f[2]++;
        cov_1qgqgcnxqf().s[2]++;
        return state.current > 0;
      },
      canRedo: state => {
        cov_1qgqgcnxqf().f[3]++;
        cov_1qgqgcnxqf().s[3]++;
        return state.current < state.list.length;
      },
      currentValue: state => {
        cov_1qgqgcnxqf().f[4]++;
        const {
          list,
          current,
          queue
        } = (cov_1qgqgcnxqf().s[4]++, state);
        cov_1qgqgcnxqf().s[5]++;
        if (current === 0) {
          cov_1qgqgcnxqf().b[0][0]++;
          cov_1qgqgcnxqf().s[6]++;
          return null;
        } else {
          cov_1qgqgcnxqf().b[0][1]++;
        }
        cov_1qgqgcnxqf().s[7]++;
        return {
          command: list[current - 1],
          data: queue[current - 1]
        };
      }
    },
    actions: {
      /**
       * Reset the store values but not the actions
       */
      reset() {
        cov_1qgqgcnxqf().f[5]++;
        cov_1qgqgcnxqf().s[8]++;
        this.$patch({
          list: [],
          current: 0,
          queue: [],
          hasCommandCalled: false
        });
      },
      /**
       * Add commands to use for undo/redo
       * inspiration http://blog.danielherzog.es/2017-01-04-javascript-command-pattern/
       * && https://github.com/yassilah/pinia-plugin-history/blob/main/src/index.ts
       * @param name => the command name
       * @param command => the commands should have an undo/redo function
       */
      addCommand(name, command) {
        cov_1qgqgcnxqf().f[6]++;
        cov_1qgqgcnxqf().s[9]++;
        if (this.commands[name]) {
          cov_1qgqgcnxqf().b[1][0]++;
          cov_1qgqgcnxqf().s[10]++;
          return;
        } else {
          cov_1qgqgcnxqf().b[1][1]++;
        }
        cov_1qgqgcnxqf().s[11]++;
        this.commands[name] = command;
      },
      /**
       * Execute a given command
       * @param name => the command name
       * @param args => all other arguments to pass into the command
       */
      async execute(name, ...args) {
        cov_1qgqgcnxqf().f[7]++;
        const {
          commands,
          list,
          queue,
          current,
          max
        } = (cov_1qgqgcnxqf().s[12]++, this);
        // remove any items after the current index
        cov_1qgqgcnxqf().s[13]++;
        this.list = list.slice(0, current);
        cov_1qgqgcnxqf().s[14]++;
        this.queue = queue.slice(0, current);
        // if we hit the max amount of history remove the last action
        cov_1qgqgcnxqf().s[15]++;
        if (list.length >= max) {
          cov_1qgqgcnxqf().b[2][0]++;
          cov_1qgqgcnxqf().s[16]++;
          this.list.splice(0, 1);
          cov_1qgqgcnxqf().s[17]++;
          this.current -= 1;
        } else {
          cov_1qgqgcnxqf().b[2][1]++;
        }
        // eslint-disable-next-line no-async-promise-executor
        cov_1qgqgcnxqf().s[18]++;
        return new Promise(async (resolve, reject) => {
          cov_1qgqgcnxqf().f[8]++;
          cov_1qgqgcnxqf().s[19]++;
          try {
            // wait for the last promise to resolve
            const queueLength = (cov_1qgqgcnxqf().s[20]++, this.queue.length);
            cov_1qgqgcnxqf().s[21]++;
            await this.queue.at(-1);
            cov_1qgqgcnxqf().s[22]++;
            this.queue.splice(queueLength, 1);
            // Exec command
            const response = (cov_1qgqgcnxqf().s[23]++, await commands[name]?.execute(...args));
            cov_1qgqgcnxqf().s[24]++;
            this.list.push(name);
            cov_1qgqgcnxqf().s[25]++;
            this.current += 1;
            cov_1qgqgcnxqf().s[26]++;
            this.lastCommand = null;
            cov_1qgqgcnxqf().s[27]++;
            this.hasCommandCalled = false;
            // add response to the queue to stop any race conditions
            cov_1qgqgcnxqf().s[28]++;
            this.queue.push({
              ...response
            });
            // Return promise response
            cov_1qgqgcnxqf().s[29]++;
            resolve(response);
          } catch (err) {
            cov_1qgqgcnxqf().s[30]++;
            reject(err);
          }
        });
      },
      /**
       * Redo the last undone command
       */
      async redo() {
        cov_1qgqgcnxqf().f[9]++;
        cov_1qgqgcnxqf().s[31]++;
        return this.stackMethod('redo');
      },
      /**
       * Undo the last command
       */
      async undo() {
        cov_1qgqgcnxqf().f[10]++;
        cov_1qgqgcnxqf().s[32]++;
        return this.stackMethod('undo');
      },
      /**
       * Undo/redo stack method
       * @param method => undo or redo string
       */
      async stackMethod(method) {
        cov_1qgqgcnxqf().f[11]++;
        cov_1qgqgcnxqf().s[33]++;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
          cov_1qgqgcnxqf().f[12]++;
          const queueLength = (cov_1qgqgcnxqf().s[34]++, this.queue.length);
          cov_1qgqgcnxqf().s[35]++;
          await this.queue.at(-1);
          cov_1qgqgcnxqf().s[36]++;
          this.queue.splice(queueLength, 1);
          const isUndo = (cov_1qgqgcnxqf().s[37]++, method === 'undo');
          const {
            commands,
            list,
            current
          } = (cov_1qgqgcnxqf().s[38]++, this);
          const can = (cov_1qgqgcnxqf().s[39]++, isUndo ? (cov_1qgqgcnxqf().b[3][0]++, current > 0) : (cov_1qgqgcnxqf().b[3][1]++, current < list.length));
          cov_1qgqgcnxqf().s[40]++;
          if (!can) {
            cov_1qgqgcnxqf().b[4][0]++;
            cov_1qgqgcnxqf().s[41]++;
            resolve('ok');
            cov_1qgqgcnxqf().s[42]++;
            return;
          } else {
            cov_1qgqgcnxqf().b[4][1]++;
          }
          cov_1qgqgcnxqf().s[43]++;
          try {
            // wait for the last promise to resolve
            const cmd = (cov_1qgqgcnxqf().s[44]++, isUndo ? (cov_1qgqgcnxqf().b[5][0]++, 'undo') : (cov_1qgqgcnxqf().b[5][1]++, 'execute'));
            // Set here to get new value before await
            cov_1qgqgcnxqf().s[45]++;
            this.lastCommand = method;
            cov_1qgqgcnxqf().s[46]++;
            this.hasCommandCalled = true;
            cov_1qgqgcnxqf().s[47]++;
            if (method === 'undo') {
              cov_1qgqgcnxqf().b[6][0]++;
              cov_1qgqgcnxqf().s[48]++;
              this.current -= 1;
            } else {
              cov_1qgqgcnxqf().b[6][1]++;
            }
            // Move back, and undo the previous command.
            const name = (cov_1qgqgcnxqf().s[49]++, this.list[this.current]);
            const response = (cov_1qgqgcnxqf().s[50]++, await commands[name][cmd]());
            cov_1qgqgcnxqf().s[51]++;
            if (method === 'redo') {
              cov_1qgqgcnxqf().b[7][0]++;
              cov_1qgqgcnxqf().s[52]++;
              this.current += 1;
            } else {
              cov_1qgqgcnxqf().b[7][1]++;
            }
            cov_1qgqgcnxqf().s[53]++;
            resolve(response);
          } catch (err) {
            cov_1qgqgcnxqf().s[54]++;
            // increase the current index as this undo failed
            if (method === 'undo') {
              cov_1qgqgcnxqf().b[8][0]++;
              cov_1qgqgcnxqf().s[55]++;
              this.current += 1;
            } else {
              cov_1qgqgcnxqf().b[8][1]++;
            }
            cov_1qgqgcnxqf().s[56]++;
            reject(err);
          }
        });
      },
      /**
       * Check if command exists in state and remove
       * all states related with it.
       * @param command - Command to delete
       */
      removeHistoryItems(command) {
        cov_1qgqgcnxqf().f[13]++;
        cov_1qgqgcnxqf().s[57]++;
        if (!(command in this.commands)) {
          cov_1qgqgcnxqf().b[9][0]++;
          cov_1qgqgcnxqf().s[58]++;
          return;
        } else {
          cov_1qgqgcnxqf().b[9][1]++;
        }
        const queueIndexes = (cov_1qgqgcnxqf().s[59]++, []);
        // Remove in commands
        cov_1qgqgcnxqf().s[60]++;
        this.list = this.list.filter((c, i) => {
          cov_1qgqgcnxqf().f[14]++;
          cov_1qgqgcnxqf().s[61]++;
          if (c === command) {
            cov_1qgqgcnxqf().b[10][0]++;
            cov_1qgqgcnxqf().s[62]++;
            queueIndexes.push(i);
          } else {
            cov_1qgqgcnxqf().b[10][1]++;
          }
          cov_1qgqgcnxqf().s[63]++;
          return c !== command;
        });
        // Remove in queue
        cov_1qgqgcnxqf().s[64]++;
        this.queue = this.queue.filter((v, i) => {
          cov_1qgqgcnxqf().f[15]++;
          cov_1qgqgcnxqf().s[65]++;
          return !queueIndexes.includes(i);
        });
        // Update current
        cov_1qgqgcnxqf().s[66]++;
        this.current -= queueIndexes.length;
      }
    }
  });
}
export default createHistoryStore;